import config from 'services/table/const';
import Action from './table.action';

let table = { ...config };

table.url = '/tms/driver';
table.columns = {
  vendor: {
    title: 'Vendor',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.vendor?.name || '-'}</div>;
    },
  },
  name: {
    title: 'Nama',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.name}</div>;
    },
  },
  phone: {
    title: 'No. Handphone',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.phone}</div>;
    },
  },
  vehicle_number: {
    title: 'No. Polisi',
    sortable: true,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return (
        <div className="text-ellipsis text-capitalize">
          {row?.vehicle_number}
        </div>
      );
    },
  },
  bank_account: {
    title: 'Akun Bank',
    sortable: false,
    format_number: false,
    width: 100,
    class: '',
    component: (row) => {
      return <div className="text-ellipsis">{row?.bank_account || '-'}</div>;
    },
  },
  user_id: {
    title: 'Envio Driver',
    sortable: false,
    format_number: false,
    width: 70,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <span
          className={
            row?.user_id && row?.user_id !== '000000000000000000000000'
              ? 'badge bg-green-lt ms-auto'
              : 'badge bg-red-lt ms-auto'
          }
        >
          {row?.user_id && row?.user_id !== '000000000000000000000000'
            ? 'Ya'
            : 'Bukan'}
        </span>
      );
    },
  },
  action: {
    title: '',
    width: 70,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
